<template>
  <router-link v-bind:to="{ name: 'work-article', params: { slug: data.slug, itemType: data.itemType } }" data-component="blurb" v-touch="touchHandler">
    <div class="blurb" :class="{'tapped': tapped}">
      <div class="blurb__background" :style="styles"></div>
      <div class="blurb__content">
        <div class="logo" v-if="data.logo">
          <img :src="data.logoWhite" :alt="blurb.headline" />
        </div>
        <div class="description">
          <div class="blurb__logo" v-if="data.logo">
            <img :src="data.logo" :alt="blurb.headline" />
          </div>
          <h1 class="headline" data-type="blurb-heading">
            {{blurb.headline}}
          </h1>
          <div class="read-more">
            Read More
          </div>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
import { Bus } from '@/helpers/bus';

export default {
  name: 'component_blurb',
  props: ['data'],
  data: function() {
    return {
      tapped: false,
    };
  },
  computed: {
    blurb: function() {
      return this.data.blurb;
    },
    styles: function() {
      let background;
      const window = this.data.window;

      if (this.data.blurb.backgroundSet) {
        background = this.data.blurb.backgroundSet.find(function(bg) {
          return window.width < bg.max;
        });
      }

      if (background) {
        background = background.src;
      } else {
        background = this.data.blurb.background;
      }

      return {
        'background-image': `url('${background}')`,
      };
    },
  },
  methods: {
    touchHandler: function(e) {
      if (this.tapped === false) {
        e.preventDefault();
        this.tapped = !this.tapped;

        Bus.$emit('tapped-blurb', this.data.slug);
      }
    },
  },
  mounted: function() {
    Bus.$on('tapped-blurb', (slug) => {
      if (this.data.slug !== slug) {
        this.tapped = false;
      }
    });
  },
};
</script>

<style lang="scss">
@import '~@/styles/_variables.scss';
@import '~@/styles/_mixins.scss';

// entire blurb is a link - remove default link styles
[data-component="blurb"] {
  display: block;

  &:hover,
  &:focus,
  &:active {
    text-decoration: none;
  }

  .blurb__logo {
    position: absolute;
    top: 0;
    left: 0;
    transform: translate(1rem, -50%);

    padding: 0 1rem;
    background: $color--primary-white;

    > img {
      height: rem(50px);
    }
  }

  .blurb__background {
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
  }

  // desktop viewport styles - asymmetrical grid
  @include mq(1024px, up) {
    .blurb {
      transition: all 250ms;

      .description,
      .blurb__logo,
      .blurb__background {
        display: flex;
        transition: all 250ms;
      }

      &:hover,
      &:focus,
      &:active,
      &.tapped {
        transform: scale(1.0125);
        .description,
        .blurb__logo,
        .blurb__background {
          box-shadow: 2px 4px 4px rgba(0, 0, 0, 0.4);
        }
      }
    }

    .blurb__content {
      .logo {
        display: none;
      }

      .description {
        display: inline-block;
        padding: 1rem;
        background: $color--primary-white;
        margin-top: -1rem;
        left: 1rem;
        padding-top: rem(35px);
      }

      .read-more {
        display: none;
      }

      .headline {
        color: $color--primary-dark;
      }
    }
  }

  // mobile viewport styles - squares
  @include mq(1024px, down) {
    // hide the desktop logo
    .blurb__logo {
      display: none;
    }

    // stretch the background to cover the entire square
    .blurb__background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    .blurb__content {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba($color--primary-highlight, 0.75);
      opacity: 0;
      transition: opacity 250ms;

      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: rem(30px);
      color: $color--primary-white;

      .logo {
        opacity: 0;
        transition: all 250ms;
        transform: translateY(-25%);

        display: flex;

        > img {
          height: rem(75px);
        }
      }

      .description {
        opacity: 0;
        transition: all 250ms;
        transform: translateY(50%);
      }

      .read-more {
        text-align: left;
      }
    }

    &[data-component="blurb"]:hover,
    &[data-component="blurb"]:active,
    &[data-component="blurb"]:focus,

    &[data-component="blurb"] .tapped {
      .blurb__content {
        opacity: 1;

        .logo,
        .description {
          transform: translateY(0);
          opacity: 1;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/blurb.vue